<template>
  <div class="evento-container">
    <div class="rasgado rasgado-superior"></div>
    <br><br>

    <!-- FLORES DECORATIVAS LATERALES -->
    <div class="flores-laterales">
      <!-- (si usas flores, coloca aquí tus <img class="flor flor1/2" ... /> ) -->
    </div>

    <!-- BOLAS DISCOTECA GIRANDO 
    <div class="bolas-container">
      <img ref="bola2" src="@/assets/disco.png" class="bola bola-right" alt="Bola disco" />
    </div>-->

    <!-- ENCABEZADO -->
    <div class="encabezado-ubicacion">
      <div class="ornamento ornamento-left"></div>
      <div class="ubicacion-linea">
      </div>
    </div>

    <!-- RECEPCIÓN / CEREMONIA -->
    <div class="evento-card">
      <img src="@/assets/mapa.png" alt="Ícono mapa" class="icono-mapa" />

      <div ref="imgRecepcion" class="evento-imagen-wrapper">
        <img src="@/assets/marco.png" class="marco-decorativo" alt="Marco decorativo" />
      </div>

      <div ref="infoRecepcion" class="evento-info">
        <!-- CEREMONIA -->
        <div class="bloque-ceremonia">
          <p class="evento-tipo">Ceremonia</p>
          <p class="evento-lugar">Immaculate Conception Church
</p>
          <p class="evento-lugar1"> 22 N 13th St, Fort Smith, AR 72901 </p>
          <p class="hora">12:00 PM</p>
          <a
            class="btn-mapa"
            href="https://maps.app.goo.gl/5KDo6PkoYBKzqjFz9"
            target="_blank"
            rel="noopener"
          >
            Cómo llegar
          </a>
        </div>
 <br>
        <!-- CELEBRACIÓN -->
        <div class="bloque-celebracion" style="margin-top: 18px;">
                  <img src="@/assets/mapa.png" alt="Ícono mapa" class="icono-mapa" />

          <p class="evento-tipo">Celebration</p>
          <p class="evento-lugar">Venue + Event Center</p>
          <p class="evento-lugar1">2400 Dodson Ave, Ft.Smith, AR</p>
          <p class="hora">4:00 PM</p>
          
        </div>

      </div>

      <div class="rasgado rasgado-inferior"></div>
    </div>

    
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const infoRecepcion = ref(null)
    const lineaDecorativa = ref(null)
    const imgRecepcion = ref(null)
    const bola2 = ref(null)
    const flor1 = ref(null)
    const flor2 = ref(null)

    // Dress code refs
    const dressCodeRef = ref(null)
    const dressLineRef = ref(null)

    const animarElemento = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, y: 60 },
        { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' }
      )
    }

    const animarDesdeIzq = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, x: -100 },
        { opacity: 1, x: 0, duration: 1.0, ease: 'power2.out' }
      )
    }

    const animarDesdeDer = (element) => {
      gsap.fromTo(
        element,
        { opacity: 0, x: 100 },
        { opacity: 1, x: 0, duration: 1.0, ease: 'power2.out' }
      )
    }

    const animarLinea = (element) => {
      gsap.fromTo(
        element,
        { scaleX: 0 },
        { scaleX: 1, transformOrigin: 'left center', duration: 1.1, ease: 'power2.out' }
      )
    }

    const rotarBola = (element) => {
      gsap.fromTo(
        element,
        { rotate: -90, scale: 0 },
        { rotate: 360, scale: 1, duration: 1.8, ease: 'elastic.out(1, 0.5)' }
      )
    }

    // Dress code animation group
    const animarDressCode = () => {
      if (!dressCodeRef.value) return
      // Fade + leve zoom del card
      gsap.fromTo(
        dressCodeRef.value,
        { opacity: 0, y: 40, scale: 0.98 },
        { opacity: 1, y: 0, scale: 1, duration: 0.9, ease: 'power2.out' }
      )
      // Línea central
      if (dressLineRef.value) animarLinea(dressLineRef.value)
      // Glow respirando
      const glow = dressCodeRef.value.querySelector('.dresscode-glow')
      if (glow) {
        gsap.to(glow, {
          opacity: 0.7,
          duration: 2,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        })
      }
      // Chispas
      const sparks = dressCodeRef.value.querySelectorAll('.sparkles .sp')
      gsap.fromTo(
        sparks,
        { opacity: 0, scale: 0.6 },
        { opacity: 0.9, scale: 1, duration: 0.6, stagger: 0.15, ease: 'power2.out' }
      )
      gsap.to(sparks, {
        y: -6,
        duration: 1.8,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut',
        stagger: 0.2
      })
    }

    onMounted(() => {
      const observar = (elRef, accion, opts = { threshold: 0.4 }) => {
        if (!elRef?.value) return
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              accion()
              obs.unobserve(entry.target)
            }
          })
        }, opts)
        observer.observe(elRef.value)
      }

      observar(imgRecepcion, () => animarElemento(imgRecepcion.value))
      observar(infoRecepcion, () => animarElemento(infoRecepcion.value))
      observar(lineaDecorativa, () => animarLinea(lineaDecorativa.value))
      observar(flor1, () => animarDesdeIzq(flor1?.value))
      observar(flor2, () => animarDesdeDer(flor2?.value))
      observar(bola2, () => rotarBola(bola2.value))

      // Dress code observer
      observar(dressCodeRef, animarDressCode, { threshold: 0.25 })
    })

    return {
      infoRecepcion,
      lineaDecorativa,
      imgRecepcion,
      bola2,
      flor1,
      flor2,
      dressCodeRef,
      dressLineRef
    }
  }
}
</script>

<style scoped>
/* ===== CONTENEDOR GENERAL ===== */
.evento-container {
  background-image:
    linear-gradient(to bottom, rgba(26, 25, 25, 0.539), rgba(0, 0, 0, 0.477)),
    url('../assets/madera.jpg');
  color: #fff;
  margin-top: -120px;
  margin-bottom: -20px;
  overflow: visible;
  background-size: cover;
  background-position: center;
  padding-bottom: 40px;
  position: relative;
}

/* ===== ENCABEZADO ===== */
.encabezado-ubicacion { text-align: center; margin-bottom: 16px; }
.linea-decorativa {
  width: 120px;
  height: 2px;
  background-color: #413d3d;
  margin: 8px auto;
  transform: scaleX(0);
}

/* ===== EVENTO CARD ===== */
.evento-card {
  max-width: 400px;
  margin: 0 auto 40px;
  text-align: center;
  padding: 0 0;
  margin-top: 30px;
  border-radius: 12px;
  overflow: hidden;
}
.icono-mapa { width: 70px; height: auto;  filter: brightness(0) invert(1); /* ← ahora es blanco */
 }
.evento-imagen-wrapper {
  position: relative; display: flex; justify-content: center; align-items: center;
  opacity: 0; filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.25));
}
.marco-decorativo {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;
  pointer-events: none; mix-blend-mode: lighten; opacity: 0.8; filter: brightness(0.4);
}
.evento-info { padding: 16px; color: #ffffff; opacity: 0; }
.hora { font-family: 'fa'; font-size: 15px; margin-bottom: 4px; color: #ffffff; }
.evento-tipo { font-family: 'britishgruesa', sans-serif; font-size: 54px; margin-bottom: 12px; color: #ffffff; }
.evento-lugar, .evento-lugar1, .evento-lugarparroquia {
  font-family: 'nombre', sans-serif; font-weight: bold; margin-bottom: 5px;
}
.evento-lugar { font-size: 20px !important; color: #ffffff; margin-top:-20px; margin-bottom: 40px; }
.evento-lugar1 { font-size: 16px !important; color: #ffffff; margin-top:-20px; margin-bottom: 40px; }
.evento-lugarparroquia { font-size: 26px !important; color: #ffffff; margin-top:-20px; }

.btn-mapa {
  margin-top: 10px; background: #ebebebc5; color: #fff; font-size: 14px; padding: 6px 16px;
  text-decoration: none; font-family: 'padres'; border-radius: 18px; font-weight: 800; display: inline-block;
  transition: background 0.3s ease, box-shadow 0.3s ease; box-shadow: 0 4px 10px rgba(0,0,0,0.25);
}
.btn-mapa:hover { background: #c49b9b; box-shadow: 0 6px 14px rgba(0,0,0,0.35); }

/* ===== BORDES RASGADOS ===== */
.rasgado { position: absolute; left: 0; width: 100%; height: 50px; background: #fff; z-index: 2; pointer-events: none; }
.rasgado-superior {
  top: 0;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
}
.rasgado-inferior {
  bottom: 0;
  clip-path: polygon(0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%, 100% 100%, 0% 100%);
}

/* ===== FLORES / BOLAS ===== */
.flores-laterales { position: relative; z-index: 12; pointer-events: none; }
.flor { position: absolute; opacity: 0; width: 290px; max-width: 40vw; z-index: 0; transition: opacity 0.3s ease; }
.flor1 { top: 500px; left: -60px; }
.flor2 { top: 1150px; right: -70px; opacity: 0; }

.bolas-container { position: relative; z-index: 3; }
.bola { position: absolute; top: -40px; width: 140px; opacity: 1; z-index: 1; }
.bola-left { left: -50px; transform: rotate(-15deg); }
.bola-right { right: -50px; top: 450px; transform: rotate(15deg); }

/* ============================== */
/*          DRESS CODE            */
/* ============================== */
.dresscode-card {
  position: relative;
  max-width: 720px;
  margin: 10px auto 60px;
  border-radius: 16px;
  background: #ffffff;
  color: #1c1b1b;
  padding: 28px 22px;
  box-shadow: 0 14px 38px rgba(0,0,0,0.08);
  overflow: hidden;
  opacity: 0; /* animado en mounted */
}
.dresscode-glow {
  position: absolute; inset: -2px;
  background: radial-gradient(1200px 300px at 50% -10%, rgba(255,255,255,0.9), rgba(255,255,255,0) 60%),
              linear-gradient(90deg, rgba(188,133,167,0.14), rgba(255,255,255,0), rgba(188,133,167,0.14));
  pointer-events: none; opacity: 0.45;
}
.dresscode-content { position: relative; z-index: 1; }

.dresscode-title {
  font-family: 'Playfair Display', 'britishgruesa', serif;
  font-size: 28px;
  letter-spacing: 0.5px;
  margin: 0 0 6px;
  color: #2f2b2b;
  text-align: center;
}
.dresscode-line {
  width: 120px; height: 2px; background: #bc85a7;
  margin: 6px auto 12px; transform: scaleX(0);
}
.dresscode-sub {
  font-family: 'nombre', sans-serif;
  font-size: 22px;
  text-align: center;
  color: #2a2929;
  margin: 0 0 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.dresscode-notes {
  max-width: 560px; margin: 0 auto 14px; padding-left: 16px;
  color: #494646; line-height: 1.6;
}
.dresscode-notes li { margin: 4px 0; }

.dresscode-tags {
  display: flex; gap: 8px; justify-content: center; flex-wrap: wrap; margin-top: 6px;
}
.tag {
  padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 600;
  background: #1f2937; color: #fff; letter-spacing: .4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
}
.tag--soft { background: #e9e5ea; color: #4b5563; }

/* Sparkles decorativos */
.sparkles { position: absolute; inset: 0; pointer-events: none; }
.sp {
  position: absolute; width: 8px; height: 8px; border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #ffffff, #ffddee 60%, rgba(255,255,255,0));
  opacity: 0.0;
}
.s1 { top: 18%; left: 12%; }
.s2 { top: 26%; right: 10%; }
.s3 { bottom: 18%; left: 20%; }

/* ===== UTILIDADES ===== */
.besos-decorativos { position: absolute; inset: 0; pointer-events: none; z-index: 3; overflow: hidden; }
.beso { filter: brightness(0.4); position: absolute; opacity: 0.32; }

/* Responsivo básico */
@media (max-width: 480px) {
  .evento-tipo { font-size: 42px; }
  .dresscode-title { font-size: 24px; }
  .dresscode-sub { font-size: 18px; }
}

/* ===== MODO IMPRESIÓN ===== */
@media print {
  .dresscode-card { box-shadow: none; }
  .sparkles, .dresscode-glow { display: none !important; }
}

/* ===== FIN ESTILOS ===== */
</style>
